import jwt_decode from "jwt-decode";
import { getTime } from "date-fns";

/**
 * 
 * @param {string} tokenString 
 * @returns {boolean} true is this is an invalid or expired token, false if it is valid and withing its expiry
 */
export function isExpiredToken(tokenString) {
    let result = true

    // if (Math.random() > 0.8) {
    //     // DEBUG: Expire 20% of the time.
    //     return true
    // }

    let tokenExpiry = null;
    try {
        const token = jwt_decode(tokenString)
        if (token.exp) {
            tokenExpiry = token.exp * 1000
        }
        console.log('isExpiredToken token', token)
    } catch (e) {
        // failed to decode token or token in wrong format so it's invalid
        console.log('isExpiredToken failed to jwt_decode, setting token expiry to null')
        tokenExpiry = null;
    }
    const now_milliseconds = getTime(new Date())
    console.log('isExpiredToken tokenExpiry', tokenExpiry)
    console.log('isExpiredToken now_milliseconds', now_milliseconds)
    if (tokenExpiry && (tokenExpiry > now_milliseconds)) {
        console.log('isExpiredToken setting result false', now_milliseconds)
        result = false;
    }
    console.log('isExpiredToken returns', (result ? 'true' : 'false'))
    return result
}

/**
 * 
 * @returns {string|null} mahi token string
 */
export function readMahiTokenString() {
    let mahiToken = localStorage.getItem('MahiToken') 
    return mahiToken ? mahiToken : null
}

/**
 * 
 * @param {string} tokenString 
 * returns {undefined}
 */
export function storeMahiTokenString(tokenString) {
    if (tokenString) {
        // console.log('[storeMahiTokenString] localStorage.setItem', tokenString)
        localStorage.setItem('MahiToken', tokenString);
    } else {
        // console.log('[storeMahiTokenString] localStorage.removeItem', tokenString)
        localStorage.removeItem('MahiToken');
    }
}

/**
 * 
 * returns {undefined}
 */
export function removeMahiTokenString() {
    localStorage.removeItem('MahiToken');
}